var _title, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgLock = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "22px",
    viewBox: "4 4 22 22",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "Icon / Events / Status / Background")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon-/-Events-/-Status-/-Background",
    stroke: "currentColor",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(9.000000, 7.000000)",
    stroke: "currentColor"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Stroke-1",
    points: "0 14.347907 12 14.347907 12 6 0 6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3,6.464884 L3,3.02580451 C3,1.35460215 4.34334627,-7.99360578e-15 5.99980908,-7.99360578e-15 C7.65703558,-7.99360578e-15 9,1.35460215 9,3.02580451 L9,6.464884",
    id: "Stroke-3"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgLock, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Lock.12eb4f50.svg";
export { ForwardRef as ReactComponent };